import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import {
  Backdrop,
  CircularProgress,
  FormControl,
  Input,
  InputLabel,
  Paper,
  Grid,
  Typography,
} from "@mui/material";

import withStyles from "@mui/styles/withStyles";

import { WideColorButton } from "../ColorButtons/ColorButtons";
import { httpPost } from "../../hooks/http";
const styles = (theme) => ({
  main: {
    display: "block", // Fix IE 11 issue.
    width: 400,
    marginLeft: "auto",
    marginRight: "auto",
  },
  paper: {
    marginTop: theme.spacing(8),
    display: "flex",
    flexDirection: "column",
    borderRadius: 25,
    alignItems: "center",
    padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(3)}`,
  },
  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    marginTop: 27,
  },

  colorUnderline: {
    borderBottom: `1px solid #0091ff`,

    "&:before": {
      borderBottom: `1px solid #0091ff`,
    },
    "&:after": {
      borderBottom: `1px solid #0091ff`,
    },
  },
  flex: {
    display: "flex",
    justifyContent: "center",
  },
  input: {
    color: "#4f6d8d !important",
  },
  error: {
    color: "red",
  },
  marginTop: {
    marginTop: 37,
  },
});

const SignIn = (props) => {
  const [isLoading, setIsLoading] = useState(true);
  const { classes, clientId, setToken } = props;
  const [errorMessage, setErrorMessage] = useState(null);
  const name = useFormInput("");
  const email = useFormInput("");

  useEffect(() => {
    if (!clientId?.length) {
      return;
    }
    const getBaseUrl = async () => {
      sessionStorage.clear();
      sessionStorage.removeItem("authToken");
      const { loaded, response } = await httpPost(
        `clientPortal/auth/GetBaseUrl`,
        { accountId: clientId },
        false
      );
      const { baseUrl } = response;
      if (!loaded || !baseUrl?.length) {
        setErrorMessage(response);
        setIsLoading(false);
        return;
      }
      let currentUrl = window.location.toString().toLowerCase();
      if (currentUrl.indexOf(baseUrl?.toLowerCase()) === -1) {
        window.location.replace(baseUrl + window.location.search);
      }
      setIsLoading(false);
    };
    getBaseUrl();
  }, [clientId]);

  const submitForm = (event) => {
    event.preventDefault();
    sessionStorage.removeItem("showOne");
    httpPost(
      `clientPortal/auth/accountLogin`,
      {
        accountId: clientId,
        emailAddress: email.value,
        name: name.value,
      },
      false
    ).then((result) => {
      if (!result.loaded) {
        setErrorMessage(result.response);
        return;
      }
      sessionStorage.setItem("authToken", clientId);
      sessionStorage.setItem("hasID", false);
      sessionStorage.setItem("email", result.response.contact.email);
      sessionStorage.setItem("lastName", result.response.contact.lastName);
      setToken(clientId, result.response);
      props.history.replace({
        pathname: "/",
        state: { eventCount: result.response.eventCount },
      });
    });
  };
  if (isLoading) {
    return (
      <Backdrop
        open
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
      >
        <CircularProgress />
      </Backdrop>
    );
  }
  return (
    <Grid
      container
      justifyContent="center"
      alignItems="center"
      className={classes.main}
    >
      <Grid item xs={12}>
        <Paper className={classes.paper}>
          <Typography component="h1" variant="h5" className={classes.marginTop}>
            Welcome to Your Portal
          </Typography>
          <form className={classes.form} onSubmit={submitForm}>
            <FormControl margin="normal" required fullWidth>
              <InputLabel className={classes.input} htmlFor="name">
                Lastname or Company Name
              </InputLabel>
              <Input
                name="name"
                type="input"
                // error={error}
                classes={{
                  underline: classes.colorUnderline,
                }}
                id="name"
                {...name}
                autoComplete="current-name"
                autoFocus
                placeholder="Last Name"
              />
            </FormControl>
            <FormControl margin="normal" required fullWidth>
              <InputLabel className={classes.input} htmlFor="email">
                Email
              </InputLabel>

              <Input
                id="email"
                name="email"
                // error={error}
                classes={{
                  underline: classes.colorUnderline,
                }}
                {...email}
                autoComplete="email"
                placeholder="Email Address"
              />
            </FormControl>

            <Grid container>
              {errorMessage?.length ? (
                <Grid item xs={12} className={classes.flex}>
                  <Typography className={classes.error} variant="subtitle1">
                    {errorMessage}
                  </Typography>
                </Grid>
              ) : null}

              <Grid item xs={12} className={classes.flex}>
                <WideColorButton
                  type="submit"
                  fullWidth
                  variant="outlined"
                  className={classes.submit}
                  color="primary"
                >
                  Sign in
                </WideColorButton>
              </Grid>
            </Grid>
          </form>
        </Paper>
      </Grid>
    </Grid>
  );
};

SignIn.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(SignIn);

function useFormInput(initialValue) {
  const [value, setValue] = useState(initialValue);
  function handleChange(e) {
    setValue(e.target.value);
  }
  return {
    value,
    onChange: handleChange,
  };
}
